import {Alert, Badge, Button, Card, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import React, {FC, useState} from "react";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {Trans, useTranslation} from "react-i18next";
import {useAuth} from "../../context/AuthProvider";
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";

type StartComponentProps = Record<string, unknown>

const StartComponent: FC<StartComponentProps> = () => {
    const {t} = useTranslation("booking");
    const nav = useNavigate()
    const auth = useAuth()
    const {axiosAuthHeader} = auth

    const [currentDemo, setCurrentDemo] = useState<any>()
    const [examsLegitimized, setExamsLegitimized] = useState<any>({hasValidLegitimizations: false})
    const [myBookings, setMyBookings] = useState<Array<any>>([])

    React.useEffect(() => {
        axios.get("/api/exam/bookings/my", axiosAuthHeader()).then((response) => {
            setMyBookings(response.data);
        });

        axios.get("/api/exam/currentDemo", axiosAuthHeader()).then((response) => {
            setCurrentDemo(response.data);
        });

        axios.get("/api/exam/legitimization", axiosAuthHeader()).then((response) => {
            setExamsLegitimized(response.data);
        });
    }, [axiosAuthHeader]);

    return (<div className="component">
        <Container>
            {/*<Alert variant="danger"><Row><Col><i className="display-1 bi bi-exclamation-diamond-fill"></i></Col><Col xs={11}><b>{t('announce.1')}</b> {t('announce.2')}</Col></Row></Alert>*/}
            {myBookings && myBookings.length > 0 ?
                <Row>
                    <Col>
                        <Card>
                            <Card.Header><h2><i className="bi bi-award"></i> {t('book.upcoming.title')}</h2>
                            </Card.Header>
                            <Card.Body>
                                <Row className="gy-2">
                                    {myBookings.map((booking: any) => <Col xs={12}>
                                            <Card>
                                                <Card.Header>{moment(booking.bookingSlot.entryAt).format('DD.MM.YYYY')} {booking.exam.name_de}</Card.Header>
                                                <Card.Body>
                                                    <Row>
                                                        <Col xs={12}>
                                                            <ul>
                                                                <li>{t('book.field.label.1')}: {moment(booking.bookingSlot.entryAt).format('HH:mm')} {t('book.field.label.5')}
                                                                </li>
                                                                <li>{t('book.field.label.2')}: {moment(booking.bookingSlot.startAt).format('HH:mm')} {t('book.field.label.5')}
                                                                </li>
                                                                { booking.handicap > 0 ? <li><b>{t('book.field.label.6')} { booking.handicap } {t('book.field.label.7')}</b></li>: null}
                                                                <li>{t('book.field.label.3')}: {moment(booking.bookingSlot.startAt).add(booking.exam.duration + booking.handicap, "minutes").format('HH:mm')} {t('book.field.label.5')}
                                                                </li>
                                                                <li>{t('book.field.label.4')}: {moment(booking.bookingSlot.leaveUntil).format('HH:mm')} {t('book.field.label.5')}
                                                                </li>
                                                            </ul>
                                                        </Col>
                                                        <Col xs={12}>
                                                            <Form className="d-flex justify-content-center">
                                                                <Form.Group as={Col} md="4" controlId="exampleForm.ControlInput1">
                                                                    <InputGroup hasValidation>
                                                                        <InputGroup.Text id="inputGroupPrepend">PIN</InputGroup.Text>
                                                                        <Form.Control
                                                                            type="text"
                                                                            readOnly={true}
                                                                            size="lg"
                                                                            aria-describedby="inputGroupPrepend"
                                                                            value={booking.pinCode}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            Please choose a username.
                                                                        </Form.Control.Feedback>
                                                                    </InputGroup>
                                                                </Form.Group>
                                                            </Form>
                                                        </Col>
                                                        <Col xs={12} className="mt-4">
                                                            {booking.bookingSlot.duration !== booking.exam.duration ? <Alert variant="warning"><i
                                                                className="bi bi-plus-slash-minus"></i> {t('book.field.badge.1')}
                                                            </Alert> : null}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className="d-flex justify-content-end">
                                                            <Button
                                                                onClick={() => nav('/bookingInfo/' + booking._id)}>{t('book.btn.toinfo')}</Button></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> : null}
            <Row>
                <Col>
                    <Card className="mt-3">
                        <Card.Header>
                            <h2><i className="bi-ui-checks"></i> {t('book.book')}</h2>
                        </Card.Header>
                        <Card.Body>
                            <Row className="mb-3">
                                <Col>
                                    {currentDemo ? <Card
                                        border={currentDemo && moment().isBetween(currentDemo.openBookingAt, currentDemo.closeBookingAt) ? 'success' : 'secondary'}>
                                        <Card.Body
                                            onClick={currentDemo && moment().isBetween(currentDemo.openBookingAt, currentDemo.closeBookingAt) ? (() => nav("/booking/" + currentDemo._id)) : undefined}
                                            style={currentDemo && moment().isBetween(currentDemo.openBookingAt, currentDemo.closeBookingAt) ? {cursor: "pointer"} : {}}>
                                            <Row
                                                className={"d-flex justify-content-around " + currentDemo && moment().isBetween(currentDemo.openBookingAt, currentDemo.closeBookingAt) ? 'text-success' : 'text-secondary'}>
                                                <Col xs={1}
                                                     className="d-flex align-items-center"><h1>
                                                    <i
                                                        className="bi bi-binoculars"></i></h1>
                                                </Col>
                                                <Col xs={5} md={10}>
                                                    <h4>{t('book.demoexam')}</h4>
                                                    <p><Badge
                                                        bg="info">{t('book.demoexam.userbasehint')}</Badge> {currentDemo ? moment().isBetween(currentDemo.openBookingAt, currentDemo.closeBookingAt) ?
                                                        <Badge
                                                            bg="secondary">{t('book.date.until')} {moment(currentDemo.closeBookingAt).format('LL')}</Badge>
                                                        : <Badge
                                                            bg="secondary">{t('book.date.prefix')} {moment(currentDemo.openBookingAt).format('LL')}</Badge> : null}
                                                    </p>
                                                </Col>

                                                <Col xs={1}
                                                     className="d-flex align-items-center"><h1>
                                                    {currentDemo && moment().isBetween(currentDemo.openBookingAt, currentDemo.closeBookingAt) ?
                                                        <i className="bi bi-arrow-right-circle-fill"></i>
                                                        : <i className="bi bi-ban"></i>}</h1>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card> : null}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                {/*<Col><Alert variant="danger"><h1>Booking Closed for Maintenance</h1><p>There is an issue with the records this system gets from TUCaN. I'll fix it and I am going to reconstruct the cancelled bookings from backups in the upcoming night.</p></Alert></Col>*/}
                                <Col>
                                    <Card
                                        border={examsLegitimized?.hasValidLegitimizations ? 'success' : 'secondary'}>
                                        <Card.Body
                                            onClick={examsLegitimized?.hasValidLegitimizations ? (() => nav("/selectExam")) : undefined}
                                            style={examsLegitimized?.hasValidLegitimizations ? {cursor: "pointer"} : {}}>
                                            <Row
                                                className={"d-flex justify-content-around " + (examsLegitimized?.hasValidLegitimizations ? 'text-success' : 'text-secondary')}>
                                                <Col xs={1}
                                                     className="d-flex align-items-center">
                                                    <h1><i
                                                        className="bi bi-award"></i></h1>
                                                </Col>
                                                <Col>
                                                    <h4>{t('book.exam')}</h4>
                                                    {/*<Badge>{examsLegitimized.length}</Badge>*/}
                                                </Col>
                                                <Col xs={1}
                                                     className="d-flex align-items-center">
                                                    <h1>{examsLegitimized?.hasValidLegitimizations ?
                                                        <i className="bi bi-arrow-right-circle-fill"></i>
                                                        :
                                                        <i className="bi bi-ban"></i>}</h1>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <Alert variant="warning">
                                <p>
                                    <b>{t('book.tucansync.hint.0')}</b> {t('book.tucansync.hint.1')}
                                </p>
                                <p>{t('book.tucansync.hint.2')}</p>
                                <p>{t('book.tucansync.hint.3')} <Link
                                    to={"/settings"}>{t('book.tucansync.hint.4')}</Link> {t('book.tucansync.hint.5')}
                                </p>
                            </Alert>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)

}
export default StartComponent
